import { Check, PersonAdd } from "@mui/icons-material";
import { KeyDriveSelect } from "../../../../components/KeydriveComponents/Selects/KeyDriveSelect";
import { Box, SelectChangeEvent } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import PrivilegesCardListing from "./PrivilegeCardListing";
import { useTranslation } from "react-i18next";
import { Group } from "../../../../model/GroupModel";
import { KeyDrivePageContainer } from "../../../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer";
import { KeyDrivePrimaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";

interface IPrivilegessStateAddingGroups {
  AddPermission: () => void;
  organizationGroups: Group[];
  handleUser(e: SelectChangeEvent): void;
  newGroupSearch: string;
  setPermissionType: (set: number) => void;
  permissionType: number;
  backBtn:() => void;
  isItemPage: boolean;
}

function PrivilegessStateAddingGroups({
  AddPermission,
  organizationGroups,
  handleUser,
  newGroupSearch,
  setPermissionType,
  permissionType,
  backBtn,
  isItemPage
}: IPrivilegessStateAddingGroups) {

  const { t } = useTranslation();

  return (
    <KeyDrivePageContainer
      icon={<PersonAdd fontSize='large' sx={{ color: "#22638D" }} />}
      title={t("Privileges.AddGroup")}
      actions={<KeyDrivePrimaryButton
        TextComponent={KeyDriveBodyMin}
        TextComponentProps={{
          color: "",
          needBold: false,
          needEllipses: false,
          text: t("Privileges.AddGroup")!
        }}
        startIcon={<Check />}
        onClick={AddPermission}
      />}
      onClickBtnBack={(e)=>backBtn()}>
      <KeyDriveSelect<Group>
        renderItem={(item) => (
          <Box display="flex" alignItems="center">
            {item.name}
            <Box ml="4px">
              <KeyDriveBodyMin
                text={`(${item.name})`}
                color="#2D2D2D"
                needBold={false}
                needEllipses={false}
                opacityParams={{
                  needOpacity: true,
                  opacityLevel: "0.5"
                }}
              />
            </Box>
          </Box>
        )}
        keyExtract={(item) => item.id!}
        items={organizationGroups}
        onChange={handleUser}
        value={newGroupSearch}
        label={t("AdminConsole.Group")}
        needFullWidth
      />
      <Box
        marginTop="30px"
        marginBottom="15px"
      >
        <KeyDriveBodyMax
          color="#2D2D2D"
          needBold
          needEllipses={false}
          text={t("Privileges.Privilege")}
        />
        <KeyDriveBodyMin
          color="#2d2d2d"
          needBold={false}
          needEllipses={false}
          text={t("Privileges.DefineWithOptionsGroup")}
        />
      </Box>
      <PrivilegesCardListing
        setPermissionType={setPermissionType}
        permissionType={permissionType}
        isItemPrivilege={isItemPage}
      />
    </KeyDrivePageContainer>
  );
}

export default PrivilegessStateAddingGroups;